import {apiClient, Model as MobxRestModel} from 'mobx-rest/lib';
import isObject from "lodash/isObject";

export class Model extends MobxRestModel {

    /*
     * Pretty much as the super rpc but uses PUT
     */
    rpcPut = function (endpoint, options, label) {
        if (label === void 0) { label = 'calling'; }
        let url = isObject(endpoint) ? endpoint.rootUrl : this.url() + "/" + endpoint;
        let _a = apiClient().put(url, options), promise = _a.promise, abort = _a.abort;
        return this.withRequest(label, promise, abort);
    };

}